import React from 'react';
import HashtagIcon from '@atlaskit/icon/core/hashtag';
import NumberField from '@atlassian/jira-issue-create-commons/src/ui/number-field/index.tsx';
import { NUMBER_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { TextFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig, ProvidedFieldProps } from '../types.tsx';
import { numberFieldWriter } from '../writers/index.tsx';

const NumberCustomFieldTypeComponent = (props: ProvidedFieldProps) => <NumberField {...props} />;

export const NumberCustomFieldTypeConfig: FieldTypeConfig<string> = {
	icon: HashtagIcon,
	type: NUMBER_CF_TYPE,
	Component: NumberCustomFieldTypeComponent,
	placeholder: <TextFieldPlaceholder />,
	writer: numberFieldWriter,
};
